<script setup lang="ts">
import ApocryphaToolbar from './ApocryphaToolbar.vue'
import ApocryphaResults from './ApocryphaResults.vue'
import { useApocryphaSearch } from '../../composables/useApocryphaSearch'

interface Props {
  frameId?: number
}

const props = withDefaults(defineProps<Props>(), {
  frameId: 0,
})

const {
  selectedBook,
  results,
  totalCount,
  isLoading,
  error,
  apocryphaBooks,
  selectBook,
  search,
} = useApocryphaSearch()

const handleBookChange = (bookId: string): void => {
  selectBook(bookId === 'all' ? 'all' : bookId)
}

const handleSearch = async (query: string, bookId: string): Promise<void> => {
  await search(query, bookId === 'all' ? undefined : bookId, 0)
}

const handleResultSelect = (): void => {
  // TODO: 實現點擊結果後的操作（如果需要）
}
</script>

<template>
  <div class="apocrypha-frame">
    <div v-if="isLoading" class="loading-state">
      <div class="spinner"></div>
      <span>載入次經書卷中...</span>
    </div>
    <div v-else-if="error" class="error-state">
      <span>⚠️ {{ error }}</span>
    </div>
    <template v-else>
      <ApocryphaToolbar
        :selected-book="selectedBook ?? 'all'"
        :is-loading="isLoading"
        :apocrypha-books="apocryphaBooks"
        @book-change="handleBookChange"
        @search="handleSearch"
      />

      <ApocryphaResults
        :results="results"
        :total-count="totalCount"
        :is-loading="isLoading"
        :error="error ?? undefined"
        @result-select="handleResultSelect"
      />
    </template>
  </div>
</template>

<style scoped>
.apocrypha-frame {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: white;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 12px;
  color: #9ca3af;
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 12px;
  color: #f87171;
  font-size: 14px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

<style scoped>
.apocrypha-frame {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: white;
}
</style>
